import groq from 'groq'

export const tagline = groq`
  _type,
  title,
  description,
`
